(function () {
  'use strict';
  if (window.btmVouchersLoaded) return;
  window.btmVouchersLoaded = true;

  function init(root) {
    if (root.dataset.ready) return;
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    const variants = JSON.parse(root.querySelector('[data-btm-variants]').textContent);
    const gift = root.querySelector('[data-btm-gift]');
    const fields = root.querySelector('[data-btm-fields]');
    const name = root.querySelector('[data-btm-name]');
    const variantInput = root.querySelector('[data-btm-variant]');
    const error = root.querySelector('[data-btm-error]');
    const choices = [...root.querySelectorAll('[data-btm-type]')];
    const digital = choices.find(el => el.dataset.btmType === 'digital');
    const printed = choices.find(el => el.dataset.btmType === 'printed');
    const buttons = [...document.querySelectorAll('button[type="submit"]')].filter(el => el.form === form);
    const prices = [...document.querySelectorAll('[data-btm-price-owner]')].filter(el => el.dataset.btmPriceOwner === form.id);
    const compares = [...document.querySelectorAll('[data-btm-compare-owner]')].filter(el => el.dataset.btmCompareOwner === form.id);
    root.dataset.ready = 'true';
    let busy = false;
    function showError(message) { error.textContent = message; error.hidden = !message; }
    function selected() { return gift.checked && printed && printed.checked ? variants.printed : variants.digital; }
    function sync() {
      const isPrinted = !!(gift.checked && printed && printed.checked);
      const current = selected();
      fields.hidden = !gift.checked;
      choices.forEach(el => { el.disabled = !gift.checked || (el === printed && !variants.printed?.available); });
      name.disabled = !gift.checked || isPrinted;
      name.required = gift.checked && !isPrinted;
      name.setCustomValidity('');
      root.querySelector('[data-btm-name-wrap]').hidden = isPrinted;
      root.querySelector('[data-btm-shipping]').hidden = !isPrinted;
      variantInput.value = current?.id || '';
      prices.forEach(el => { el.textContent = current?.price || ''; });
      compares.forEach(el => { el.textContent = current?.compare || ''; el.hidden = !current?.compare; });
      buttons.forEach(el => { el.disabled = busy || !current?.available; });
      showError(current?.available ? '' : 'Tato varianta nyní není dostupná.');
    }
    gift.disabled = !variants.digital;
    gift.addEventListener('change', sync);
    choices.forEach(el => el.addEventListener('change', sync));
    name.addEventListener('input', () => { name.setCustomValidity(''); showError(''); });
    if (root.dataset.productPage === 'true') {
      const params = new URLSearchParams(window.location.search);
      if (params.get('darek') === '1' || params.get('gift') === '1') gift.checked = true;
      if (printed && variants.printed.available && params.get('variant') === variants.printed.id) {
        gift.checked = true; printed.checked = true; digital.checked = false;
      }
    }
    form.addEventListener('submit', async function (event) {
      const current = selected();
      if (busy || !current?.available || (!name.disabled && !name.value.trim())) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (!name.disabled && !name.value.trim()) {
          name.setCustomValidity('Vyplňte jméno obdarovaného.');
          showError('Pro online voucher vyplňte jméno obdarovaného.');
          name.reportValidity(); name.focus();
        }
        return;
      }
      // Ensure a physical order never submits a stale personalization field.
      if (!name.disabled) name.value = name.value.trim();
      variantInput.value = current.id;
      if (!form.hasAttribute('data-btm-city-form')) return;
      event.preventDefault(); event.stopImmediatePropagation();
      busy = true; sync();
      const routeRoot = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(routeRoot + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : 'Produkt se nepodařilo přidat do košíku.');
        window.location.assign(routeRoot + 'cart');
      } catch (err) {
        busy = false; sync();
        showError(err.message || 'Přidání do košíku se nepodařilo. Obnovte košík a zkontrolujte jeho obsah.');
      }
    }, true);
    sync();
    window.addEventListener('pageshow', sync);
  }
  function scan() { document.querySelectorAll('[data-btm-voucher]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
